var exports = {
  "i": "x93eb46d8--f8dca6--wrapper",
};

module.exports = exports;
